import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PsContext from "../../../context";
import { DB_POSTFIX } from "../../../utils";
import { ServiceUrl } from "../../../utils/serviceUrl";

const Footer = (props) => {
  const context = useContext(PsContext);
  const [quickLinks, setQuickLinks] = useState([]);

  useEffect(() => {
    LoadData();
  }, []);

  const LoadData = () => {
    axios.get(ServiceUrl.LINKS + "?sadb=" + DB_POSTFIX).then((res) => {
      if (res["data"].status == "1") setQuickLinks(res["data"].data);
    });
  };

  return (
    <>
      <section className="footer">
        <div className="container">
          <div className="wed-foot-link ">
            <div className="row ">
              <Col md={3}>
                <Card className="bg-transparent text-white">
                  <Card.Header>Information</Card.Header>
                  <Card.Body className="text-white">
                    <ul>
                      <li>
                        <a href="#" className="fw-bold text-white">
                          {context.settingValue("web_site_name")}
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-white">
                          <i className="fa fa-map-marker-alt me-2 fs-6"></i>
                          {context.settingValue("web_site_address_line1")}
                          {", "} {context.settingValue("web_site_address_city")}
                          {", "}
                          {context.settingValue("web_site_address_state")}
                          {", "}
                          {context.settingValue("web_site_address_country")}
                          {" - "}
                          {context.settingValue("web_site_address_pincode")}
                        </a>
                      </li>
                      <li>
                        <a href="#" className="text-white">
                          <i className="fa fa-phone me-2 fs-6"></i>
                          {context.settingValue("web_site_enquiry_phone")}{" "}
                          {context.settingValue("web_site_enquiry_mobile")}
                        </a>
                      </li>

                      <li className="text-white">
                        <i className="fa fa-envelope me-2 fs-6"></i>
                        <a
                          href={`mailto:${context.settingValue(
                            "web_site_enquiry_email"
                          )}`}
                          className="text-white"
                        >
                          {context.settingValue("web_site_enquiry_email")}
                        </a>
                      </li>
                      <li className="mt-2">
                        <a
                          href={context.settingValue("web_site_social_youtube")}
                          target="_blank"
                        >
                          <i className="fa-brands fa-youtube fs-4 me-3 text-white"></i>
                        </a>
                        <a
                          href={context.settingValue(
                            "web_site_social_facebook"
                          )}
                          target="_blank"
                        >
                          <i className="fa-brands fa-facebook fs-4 me-3 text-white"></i>
                        </a>
                        <a
                          href={context.settingValue(
                            "web_site_social_instagram"
                          )}
                          target="_blank"
                        >
                          <i className="fa-brands fa-instagram fs-4 me-3 text-white"></i>
                        </a>
                        <a
                          href={context.settingValue("web_site_social_twitter")}
                          target="_blank"
                        >
                          <i className="fa-brands fa-twitter fs-4 me-3 text-white"></i>
                        </a>
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={5}>
                <Card className="bg-transparent text-white">
                  <Card.Header>Location</Card.Header>
                  <Card.Body>
                    <iframe
                      src={context.settingValue("web_site_gmap_iframe_link")}
                      width="100%"
                      height="250"
                      style={{ border: "0" }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="bg-transparent text-white">
                  <Card.Header>Useful Links</Card.Header>
                  <Card.Body>
                    <ul>
                      {quickLinks.map((item, i) => (
                        <li>
                          {item.linktype == "page" && (
                            <Link
                              to={item.menulink}
                              key={i}
                              className="fs-6 text-white"
                            >
                              <i className="fa-solid fa-caret-right me-2 fs-6"></i>
                              {item.title}
                            </Link>
                          )}
                          {item.linktype == "external" && (
                            <a
                              href={item.menulink}
                              key={i}
                              className="fs-6  text-white"
                              target="_blank"
                            >
                              <i className="fa-solid fa-caret-right me-2 fs-6"></i>
                              {item.title}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              {/* <Col md={3}>
                <Card className="border-0 shadow">
                  <Card.Header
                    style={{
                      color: `${context.settingValue(
                        "web_site_header_textcolor"
                      )}`,
                    }}
                  >
                    Useful Links
                  </Card.Header>
                  <Card.Body style={{ minHeight: "320px" }}>
                    <ul>
                      {quickLinks.map((item, i) => (
                        <li>
                          {item.linktype == "page" && (
                            <Link to={item.menulink} key={i} className="fs-6">
                              <i className="fa-solid fa-caret-right me-2 fs-6"></i>
                              {item.title}
                            </Link>
                          )}
                          {item.linktype == "external" && (
                            <a
                              href={item.menulink}
                              key={i}
                              className="fs-6"
                              target="_blank"
                            >
                              <i className="fa-solid fa-caret-right me-2 fs-6"></i>
                              {item.title}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
